import {CustomAttributeDefinition} from '@api/graphql'
import {FilterItemState, FilterItemDefinition, SimpleFilterItemDefinition} from '@modules'
import {ui, useCatalog} from '@stores'
import {React, observer} from '@api'
import {FilterGroupItem} from './';

interface MyProps {
  item: SimpleFilterItemDefinition
  group: string
  type: string
  selected: Map<string, FilterItemState>
  excluded: Map<string, FilterItemState>
  grouped?: { [v: string]: Array<any> }
  customAttribute?: CustomAttributeDefinition
  count?: number
  displayName?: string
  showIcon?: boolean
}

export const FilterSpecGroupItem = observer<MyProps>(function FilterSpecGroupItem({
  selected, excluded, group, type, displayName,
  item, ...props
}) {
  const {compoundId, id} = item,
    {imageUrlFor, _fieldByName, labelFor} = useCatalog()

  return (
    <FilterGroupItem
      checked={selected.has(compoundId) || selected.has(id.toString())}
      excluded={excluded.has(compoundId) || excluded.has(id.toString())}
      name={labelFor(item)}
      type={type}
      displayName={displayName}
      imageUrl={group != 'tags' && imageUrlFor(_.first(item.images))}
      item={item}
      {...props}
      showIcon={_fieldByName[group]?.esIndex != null}
    />
  )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/FilterSpecGroupItem.tsx